import React, { useState, useEffect } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { ListAdmin } from "./listofAdmin";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate, useParams } from "react-router-dom";
import { axiosInstance } from "../../axiosInstance";
import { useFormik } from "formik";
import { object, string } from "yup";
import { toast } from "react-toastify";

const validationSchema = object().shape({
  username: string().required("User Name is required"),
  last_name: string().required("Last Name is required"),
  first_name: string().required("First Name is required"),
  email: string().email("Invalid email").required("Email is required"),
  mobile_no: string("Invalid mobile no").required("mobile no is required"),
});

export function EditAdmin() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const formik = useFormik({
    initialValues: {
      username: "",
      first_name: "",
      last_name: "",
      email: "",
      mobile_no: "",
      user_type: "admin",
      is_active: true,
      // password: "GomakAdmin@123",
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const payload = {
          username: values.username.trim(),
          first_name: values.first_name.trim(),
          last_name: values.last_name.trim(),
          email: values.email.trim(),
          mobile_no: values.mobile_no,
          user_type: "admin",
          is_active: values.is_active,
          // password: "GomakAdmin@123",
        };

        const response = await axiosInstance.patch(
          `/admin/admin-list/${id}/`,
          payload
        );

        if (response.data.status === "success") {
          toast.success("Admin updated successfully!");
          setTimeout(() => navigate("/manage-admin"), 1500);
        } else {
          toast.error(response.data.message || "Failed to update admin.");
        }
      } catch (err) {
        console.error("❌ Error updating admin:", err);
        toast.error("Something went wrong. Please try again.");
      } finally {
        setLoading(false);
      }
    },
  });

  const handleCancel = () => {
    navigate("/manage-admin");
  };

  useEffect(() => {
    const fetchAdminDetails = async () => {
      try {
        const res = await axiosInstance.get(`/admin/admin-list/${id}`);
        if (res.data.status === "success" && res.data.data) {
          formik.setValues({
            username: res.data.data.username || "",
            first_name: res.data.data.first_name || "",
            last_name: res.data.data.last_name || "",
            email: res.data.data.email || "",
            mobile_no: res.data.data.mobile_no || "",
            user_type: res.data.data.user_type || "admin",
            is_active: res.data.data.is_active ?? true,
          });
        } else {
          toast.error("Failed to load admin details.");
        }
      } catch (err) {
        console.error("Error fetching admin data:", err);
        toast.error("Something went wrong while loading admin data.");
      }
    };

    fetchAdminDetails();
  }, [id]);

  return (
    <div className="addAdmin-container">
      <div className="addAdmin-subcontainer">
        <FaArrowLeftLong
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/manage-admin");
          }}
        />
        <div className="add-title">Edit Admin</div>
      </div>
      {/* <div className="note-section-password">
        <p>
          <strong>Note:</strong> When an admin user is created, the default
          password will be set to <strong>GomakAdmin@123</strong>. Please advise
          the user to change it after first login.
        </p>
      </div> */}
      <form onSubmit={formik.handleSubmit}>
        <div className="addAdmin-content">
          <div className="addAdmin-contentLeft">
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> User Name
              </label>
              <div>
                <input
                  type="text"
                  placeholder="Enter Your User Name"
                  name="username"
                  value={formik.values.username}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.username && formik.errors.username && (
                  <div className="text-danger">{formik.errors.username}</div>
                )}
              </div>
            </div>
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> Last Name
              </label>
              <div>
                <input
                  type="text"
                  name="last_name"
                  placeholder="Enter Your Last Name"
                  value={formik.values.last_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.last_name && formik.errors.last_name && (
                  <div className="text-danger">{formik.errors.last_name}</div>
                )}
              </div>
            </div>
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> Mobile Number
              </label>
              <div>
                <input
                  type="text"
                  name="mobile_no"
                  placeholder="Enter Your Mobile Number"
                  value={formik.values.mobile_no}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.mobile_no && formik.errors.mobile_no && (
                  <div className="text-danger">{formik.errors.mobile_no}</div>
                )}
              </div>
            </div>
          </div>
          <div className="addAdmin-contentRight">
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> First Name
              </label>
              <div>
                <input
                  type="text"
                  name="first_name"
                  placeholder="Enter Your First Name"
                  value={formik.values.first_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.first_name && formik.errors.first_name && (
                  <div className="text-danger">{formik.errors.first_name}</div>
                )}
              </div>
            </div>
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> Email
              </label>
              <div>
                <input
                  type="text"
                  name="email"
                  placeholder="Enter Your Email id"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email && (
                  <div className="text-danger">{formik.errors.email}</div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="addbtnContainer">
          <div>
            <button
              type="button"
              className="admin-btnCancel"
              onClick={handleCancel}
              disabled={loading}
            >
              Cancel
            </button>
          </div>
          <div>
            <button className="add-btnSave">Update</button>
          </div>
        </div>
      </form>
    </div>
  );
}
